import { CardNumberElement } from '@stripe/react-stripe-js';
import styled from 'styled-components';

import { stripeInputStyles, TProps } from './stripeInputStyles';

export const StyledCardNumberElement = styled(CardNumberElement)<TProps>`
  ${stripeInputStyles}
`;
